import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SocialSharing, GlobalContext } from 'commons';
import { orgId, baseUrl } from 'utils';
import ItemTitle from './ItemTitle';
import ItemDate from './ItemDate';
import ItemDetail from './ItemDetail';

const Item = ({ notification, index }) => {
  const {
    organization: { showNotificationsToMemberPortalSocialSharing, isPublic }
  } = useContext(GlobalContext);
  const { priority, notificationId: id, title, sendDate, textMessage } = notification;

  return (
    <div className="box-list" item-id={id}>
      <ItemTitle {...{ priority, id, title, index }} />
      <ItemDate id={id} date={sendDate} />
      {isPublic && showNotificationsToMemberPortalSocialSharing && (
        <SocialSharing
          url={`${baseUrl}/${orgId}/notif/${id}`}
          title={title}
          description={textMessage}
        />
      )}
      <ItemDetail {...{ id, textMessage }} />
    </div>
  );
};

Item.propTypes = {
  notification: PropTypes.shape({
    [PropTypes.string]: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  }).isRequired,
};

export default Item;
